function jumpToAnchor(id: string) {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView();
  }
}
export default jumpToAnchor;
